import { render, staticRenderFns } from "./StubRedirect.vue?vue&type=template&id=5bbe6d12&scoped=true&"
import script from "./StubRedirect.vue?vue&type=script&lang=js&"
export * from "./StubRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbe6d12",
  null
  
)

export default component.exports